import SmoothScroll from 'smooth-scroll';
import '@fancyapps/fancybox';
import {fitGoogleMapMarkers} from "./modules/map";

var navTimeouts = [];
var $html = $( 'html' );

var smoothScroll = new SmoothScroll( 'a[href*="#"]', {
	topOnEmptyHash: false,
	updateURL: false,
	speed: 1000,
	speedAsDuration: true,
	offset: function( anchor, toggle ) {
		return 0;
	},
} );

$( function() {
	sanitizeTargetBlank();

	$( '.fancybox' ).fancybox( {} );

	$( '.hamburger-toggle' ).on( 'click', function( event ) {
		if ( $html.hasClass( 'active-main-menu' ) ) {
			closeHamburger();
		} else {
			openHamburger();
		}
	} );

	$( '.project-hamburger-toggle' ).on( 'click', function( event ) {
		if ( $html.hasClass( 'active-main-menu' ) ) {
			closeHamburger( true );
		} else {
			openHamburger( true );
		}
	} );

	$( '.hamburger-close' ).on( 'click', function( event ) {
		closeHamburger();
	} );

	$( '.toggle' ).on( 'click', function( event ) {
		let $this = $( this );

		$this.find( '.open, .close' ).toggleClass( 'opacity-0 opacity-100 rotate-90' );

		$this.parents( '.toggle-container' ).find( '.toggle-content' ).toggle( 200 );
	} );

	$( '.filter-group .filter-group-toggle' ).on( 'click', function() {
		var $this = $( this );

		$( '.filter-group' ).find( '.filter-items-container' ).stop().slideUp( 'fast' );
		// $( '.filter-group' ).find( '.filter-group-arrow' ).removeClass( '-rotate-90' ).addClass( 'rotate-90' );

		$this.parents( '.filter-group' )
			.find( '.filter-items-container' ).stop().slideToggle( 'fast' );
		// $this.parents( '.filter-group' )
		// 	.find( '.filter-group-arrow' ).removeClass( 'rotate-90' ).addClass( '-rotate-90' );
	} );

	$( '.project-menu' ).on( 'click', function() {
		closeHamburger( true );
	} );
} );

var newScrollTop,
	currentScrollTop = 0,
	scrollTarget = $( 'html' );

$( window ).scroll( function() {
	var scrollTop = $( window ).scrollTop();
	var scrollThreshold = $( '.site-header' ).outerHeight() + $( '.project-header' ).outerHeight();

	if ( isNaN( scrollThreshold ) ) {
		scrollThreshold = 20;
	}

	if ( scrollTop > scrollThreshold * 2 ) {
		scrollTarget.addClass( 'scrolling' ).removeClass('at-top');

		currentScrollTop = scrollTop;

		if ( newScrollTop < currentScrollTop ) {
			scrollTarget.addClass( 'scroll-down' ).removeClass( 'scroll-up' );
		} else if ( newScrollTop > currentScrollTop ) {
			scrollTarget.removeClass( 'scroll-down' ).addClass( 'scroll-up' );
		}
		newScrollTop = currentScrollTop;
	} else {
		scrollTarget.removeClass( 'scroll-down scrolling scroll-up' ).addClass('at-top');
	}

	$( '#open-cta' ).on( 'click', function( event ) {
		$( 'body' ).removeClass( 'inactive-cta' ).addClass( 'active-cta' );
		console.log('Activate');
	} );

	$( '#close-cta' ).on( 'click', function( event ) {
		$( 'body' ).removeClass( 'active-cta' ).addClass( 'inactive-cta' );
		console.log('Close');

	} );
} );

function openHamburger( projectHamburger ) {
	$html.addClass( 'active-main-menu' );

	if ( projectHamburger ) {
		$( '.project-hamburger-toggle' ).addClass( 'active' ).addClass( '!bg-transparent' ).find( '.open, .close' ).toggleClass( 'opacity-0 opacity-100 rotate-90' );

		$( '.project-site-navigation' ).addClass( '!pointer-events-auto !opacity-100' );

		$( '.project-site-navigation-nav-container' ).removeClass( 'translate-x-full' );
	} else {
		$( '.hamburger-toggle' ).addClass( 'active' ).addClass( '!bg-transparent' ).find( '.open, .close' ).toggleClass( 'opacity-0 opacity-100 rotate-90' );

		$( '.site-navigation-secondary' ).addClass( '!pointer-events-auto !opacity-100' );

		$( '.site-navigation-nav-container' ).removeClass( 'translate-x-full' );

		$( '.site-navigation-menu li' ).each( function( index ) {
			let $this = $( this );

			navTimeouts.push( setTimeout( function() {
				$this.addClass( 'active' );
			}, 600 + index * 50 ) );
		} );
	}
}

export function closeHamburger( projectHamburger ) {
	if ( projectHamburger ) {
		$( '.project-hamburger-toggle' ).removeClass( 'active' ).removeClass( '!bg-transparent' ).find( '.open, .close' ).toggleClass( 'opacity-0 opacity-100 rotate-90' );

		$( '.project-site-navigation' ).removeClass( '!pointer-events-auto !opacity-100' );

		$( '.project-site-navigation-nav-container' ).addClass( 'translate-x-full' );
	} else {
		$( '.hamburger-toggle' ).removeClass( 'active' ).removeClass( '!bg-transparent' ).find( '.open, .close' ).toggleClass( 'opacity-0 opacity-100 rotate-90' );

		$( '.site-navigation-secondary' ).removeClass( '!pointer-events-auto !opacity-100' );

		$( '.site-navigation-menu li' ).removeClass( 'active' );

		$( '.site-navigation-nav-container' ).addClass( 'translate-x-full' );

		navTimeouts.forEach( function( timeout ) {
			clearTimeout( timeout );
		} );

		navTimeouts = [];
	}

	$html.removeClass( 'active-main-menu' );
}

/* 3/24/2017 Sanitize_Target_Blank.htm https://gist.github.com/JamoCA/80f65eb07f054b1326221bd4f15868d6 */
function sanitizeTargetBlank() {
	$( 'a[rel~=external]' ).prop( 'target', '_blank' );
	$( 'a[target="_blank"]' ).each( function() {
		var a = $( this );
		if ( location.hostname !== this.hostname ) {
			var originalRel = (this.rel === undefined) ? '' : this.rel.toLowerCase();
			var newRel = originalRel.split( " " );
			if ( originalRel.indexOf( 'noopener' ) === -1 ) {
				newRel.push( 'noopener' );
			}
			if ( originalRel.indexOf( 'noreferrer' ) === -1 ) {
				newRel.push( 'noreferrer' );
			}
			if ( originalRel.indexOf( 'nofollow' ) === -1 ) {
				newRel.push( 'nofollow' );
			}
			a.attr( 'rel', newRel.join( " " ).trim() );
		}
	} );
	console.log( 'External AHREF links have been sanitized.', new Date );
}

function viewRel() {
	var linkLog = [];
	console.log( 'Identifying all AHREF links with target="_blank"...' );
	$( 'a[target="_blank"]' ).each( function( i ) {
		var a = $( this );
		var r = a.attr( 'rel' );
		if ( r !== undefined ) {
			r = r.split( " " );
		}
		var entry = {
			'index': i,
			'linkText': a.text(),
			'href': a.attr( 'href' ),
			'target': a.attr( 'target' ),
			'rel': r,
		};
		linkLog.push( entry );
	} );
	console.table( linkLog );
}

$( function() {
	$( '.boolean-toggle' ).each( function() {
		const $toggles = $( '*[data-toggle-target]', $( this ) );
		$toggles.click( function() {
			const clickedTargetId = $( this ).attr( 'data-toggle-target' );
			$toggles.each( function() {
				const $this = $( this );
				$this.toggleClass( 'hidden', !$this.hasClass( 'hidden' ) );

				const targetId = $this.attr( 'data-toggle-target' );
				const $target = $( '#' + $this.attr( 'data-toggle-target' ) );
				$target.toggleClass( 'hidden', targetId === clickedTargetId );
			} );
			window.msnry.masonry();
			fitGoogleMapMarkers();
		} );
	} );
} );
